import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { cn } from "@/lib/utils";

export const CONTACT_EMAIL = "contact@elevintia.com";

export default function CopyEmailButton({ className }: { className?: string }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = window.setTimeout(() => setCopied(false), 2000);
    return () => window.clearTimeout(timer);
  }, [copied]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(CONTACT_EMAIL);
      setCopied(true);
    } catch {
      window.location.href = `mailto:${CONTACT_EMAIL}`;
    }
  };

  return (
    <button
      type="button"
      onClick={copy}
      className={cn(
        "inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-xs text-white/70 transition-colors hover:border-white/30 hover:text-white",
        className
      )}
    >
      <Icon
        icon={
          copied
            ? "material-symbols:check-rounded"
            : "material-symbols:content-copy-outline-rounded"
        }
        className={cn("text-sm", copied && "text-[#DEFF77]")}
      />
      <span aria-live="polite">
        {copied ? "Copied to clipboard" : "Copy email"}
      </span>
    </button>
  );
}
